import React, { useCallback, useEffect, useState } from 'react';
import {
  Outlet,
  useNavigate,
  useOutletContext,
  useParams,
} from 'react-router-dom';
import { Box, MenuItem, Select } from '@mui/material';

export function Temoins() {
  const infos = useOutletContext();
  const { temoinId, '*': rest } = useParams();
  const navigate = useNavigate();

  const hasTemoins = infos.settings?.temoins?.show;
  const lots = infos.settings?.temoins?.data;

  const [lot, setLot] = useState(lots && lots.length > 0 ? lots[0] : null);

  useEffect(() => {
    if (!temoinId) {
      navigate('./' + lots[0]['path']);
      return;
    } else {
      if (!rest) {
        navigate('maquette');
      }
      const media = lots.find((l) => l.path === temoinId);
      setLot({ key: media.path, infos: {}, medias: media });
    }
  }, [rest, temoinId, navigate, lots]);

  const handleChangeMedia = useCallback(
    (event) => {
      navigate('../../' + event.target.value, { relative: 'path' });
    },
    [navigate],
  );

  if (!hasTemoins) return null;

  return temoinId ? (
    <Box sx={{ height: '100%', overflow: 'auto', position: 'relative' }}>
      <Outlet context={{ lot, settings: infos }} />
      <Select
        labelId="select-label-lot-temoin"
        id="select-lot-temoin"
        value={temoinId}
        label="Sélectionner un lot"
        onChange={handleChangeMedia}
        sx={{ position: 'absolute', width: '200px', top: '24px', left: '24px' }}
      >
        {lots.map((lot, index) => (
          <MenuItem value={lot.path} key={index}>
            {lot.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  ) : null;
}
